import { Stack, Typography } from '@mui/material'
import { type ReactNode } from 'react'

type Props = {
  title: string
  children?: ReactNode
}

// MEMO: グローバルなコンポーネントと共通化できるかも？
export const PageHeader = ({ title, children }: Props) => {
  return (
    <Stack
      sx={{
        height: 72,
        minHeight: 72,
        px: 3,
        bgcolor: 'white',
        boxShadow: 'none',
        borderBottom: 1,
        borderColor: 'divider',
      }}
      gap={2}
      direction="row"
      alignItems="center"
    >
      <Typography
        variant="h1"
        sx={{
          flexGrow: 1,
          color: 'text.primary',
          fontWeight: 'bold',
          fontSize: '20px',
        }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  )
}
